import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const SignInInputWithLabel =
    ({ labelText, filedName, type, onChange, value, error, errorMessage, }) => {

  const classes = useStyles({ error, })
  return (
    <label>
        {labelText}
      <input
        className={classes.input}
        onChange={ (e) => onChange(e.target.value, filedName)}
        name={filedName}
        type={type}
        value={value}
      />
      <p className={classes.error}>
        { error && errorMessage }
      </p>
    </label>
  )
}

SignInInputWithLabel.propTypes = {
  labelText: PropTypes.string.isRequired,
  filedName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
}

SignInInputWithLabel.defaultProps = {
  type: 'text',
  value: '',
}
const useStyles = createUseStyles({
  input: ({ error, }) => ({
    width: '100%',
    height: '50px',
    border: `2px solid ${error ? '#ec8282' : '#E5E3E8'}`,
    borderRadius: '5px',
    fontWeight: '400',
    color: '#393939',
    fontSize: '14px',
    paddingLeft: '1em',
    marginTop: '0.3em',
    outline: 'none',
    transition: '200ms all linear',
    '&:hover': {
      borderColor: '#57c2ef',
    },
    '&:focus': {
      boxShadow: '0 0 4px 1px #57c2ef',
    },
  }),
  error: {
    marginTop: '0px',
    color: '#ec8282',
    fontWeight: '700',
  },
})
export default SignInInputWithLabel
